import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingBarModule } from '@ngx-loading-bar/core';

import { SharedModule } from '../../shared/shared.module';

import { NgxCurrencyModule } from "ngx-currency";
export const currencyMask = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true
};

import {
  EquipmentsComponent,
  EquipmentsListComponent,
  EquipmentsNewComponent,
  EquipmentsEditComponent
} from './';

@NgModule({
  declarations: [
    EquipmentsComponent,
    EquipmentsListComponent,
    EquipmentsNewComponent,
    EquipmentsEditComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    LoadingBarModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCurrencyModule.forRoot(currencyMask)
  ]
})
export class EquipmentsModule { }
